import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

// GET_TICKET_TYPE_LIST
export const getTicketTypeList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.TICKET.GET_TICKET_TYPE_LIST,
    { params: params }
  );

  console.log(
    "🚀 ~ TicketRepo.ts:10 ~ getTicketTypeList ~ response:",
    response
  );

  return response?.data;
};

export const getTicketList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.TICKET.GET_TICKET_LIST,
    { params: params }
  );

  console.log("🚀 ~ TicketRepo.ts:25 ~ getTicketList ~ response:", response);

  return response?.data;
};

export const getTicketConfigStatus = async () => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.TICKET.GET_TICKET_CONFIG_STATUS
  );

  console.log(
    "🚀 ~ TicketRepo.ts:35 ~ getTicketConfigStatus ~ response:",
    response
  );

  return response?.data;
};
// ADD_TICKET

export const addTicket = async (body?: any) => {
  return axiosInstance.post(API_ENDPOINTS.TICKET.ADD_TICKET, body);
};

// UPDATE_TICKET
export const updateTicket = async (id?: string | number, body?: any) => {
  return axiosInstance.put(`${API_ENDPOINTS.TICKET.UPDATE_TICKET}/${id}`, body);
};

// GET_TICKET_REPLIES

export const getTicketRepliesList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.TICKET.GET_TICKET_REPLIES,
    { params: params }
  );

  console.log(
    "🚀 ~ TicketRepo.ts:64 ~ getTicketRepliesList ~ response:",
    response
  );

  return response?.data;
};

// ADD_TICKET_REPLIES
export const addTicketReplies = async (body?: any) => {
  return axiosInstance.post(API_ENDPOINTS.TICKET.ADD_TICKET_REPLIES, body);
};

// UPDATE_TICKET_REPLIES
export const updateTicketReplies = async (body?: any) => {
  return axiosInstance.put(API_ENDPOINTS.TICKET.UPDATE_TICKET_REPLIES, body);
};
